import { aboutData } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-500/15 text-accent-400 text-xs font-medium mb-3 whitespace-nowrap">
            关于我们
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading mb-6">
            {aboutData.title}
          </h2>

          <div className="flex flex-col gap-4 mb-10">
            <p className="text-foreground-400 text-sm md:text-base leading-relaxed max-w-3xl mx-auto">
              {aboutData.desc1}
            </p>
            <p className="text-foreground-400 text-sm md:text-base leading-relaxed max-w-3xl mx-auto">
              {aboutData.desc2}
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-8">
            {aboutData.stats.map((stat) => (
              <div key={stat.label} className="text-center p-4">
                <div className="text-2xl md:text-3xl font-bold text-primary-400 font-heading mb-1">
                  {stat.value}
                </div>
                <div className="text-sm text-foreground-500">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}